import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { createVersionedAgent } from "./schema/agents/create-versioned-agent";
import { exportMerchantSupportThreads } from "./schema/agents/export-merchant-support-threads";
import { findAllLatestAgents } from "./schema/agents/find-all-latest-agents";
import { getAgentById } from "./schema/agents/get-agent-by-id";
import { getAgentByNameAndVersion } from "./schema/agents/get-agent-by-name-and-version";
import { getAgentNames } from "./schema/agents/get-agent-names";
import { getChildThreads } from "./schema/agents/get-child-threads";
import { getIntercomConversationCount } from "./schema/agents/get-intercom-conversation-count";
import { getMerchantSupportThreads } from "./schema/agents/get-merchant-support-threads";
import { getThreadById } from "./schema/agents/get-thread-by-id";
import { getThreadsByVersionedAgent } from "./schema/agents/get-threads-by-versioned-agent";
import { getTriageV2Threads } from "./schema/agents/get-triage-v2-threads";
import { listAgentsByName } from "./schema/agents/list-agents-by-name";
import { publishVersionedAgent } from "./schema/agents/publish-versioned-agent";
import { updateVersionedAgent } from "./schema/agents/update-versioned-agent";

const versionedAgents = {
  createVersionedAgent,
  updateVersionedAgent,
  publishVersionedAgent,
  findAllLatestAgents,
  listAgentsByName,
  getAgentById,
  getAgentNames,
  getAgentByNameAndVersion,
  getThreadsByVersionedAgent,
  getThreadById,
  getChildThreads,
  getMerchantSupportThreads,
  getTriageV2Threads,
  exportMerchantSupportThreads,
  getIntercomConversationCount,
};

export const rpcDefinition = { ...versionedAgents };

export type AdminAgentsRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
